<template>
  <transition name="cycleFromLeft" mode="out-in">
    <div class="question vh-for-mobile" :data-variant="variant">

      <div class="wrapper">


        <div class="wrapper__left">
          <div v-if="config.shortText" class="question__shortText" v-html="config.shortText"></div>

          <div v-if="config.image && !config.imageAfterText" class="question__image">
            <img :src="config.image" alt=""/>
          </div>

          <div v-if="config.fullText" class="question__fullText" v-html="config.fullText"></div>


          <div v-if="hasOverlay" class="question__info hidden-xs" @click="openInfoOverlay(config.info)">
            <img :src="returnBasePath('/assets/img/shared/icon-help.png')" alt="Info"/>
            <span @click="openInfoOverlay(config.info)">{{config.info.label}}</span>
          </div>


        </div>

        <div class="wrapper__right">

          <transition name="slideLeft" mode="out-in">
            <div v-if="config.answers" class="question__answers">

              <div v-if="config.image && config.imageAfterText" class="question__image--big">
                <img :src="config.image" alt=""/>
              </div>

              <div v-for="(item, index) in config.answers"
                   :key="item.id"
                   :class="{'question__answers__item': true, 'is-disabled': item.disabled, 'with-icon': item.icon}">
                <div class="question__answers__item__wrapper"
                     @click="retrieveNextStep(config.id, item, item.value)"
                     :ref="{'imageBox': item.image}">
                  <img v-if="item.icon" :src="item.icon" :alt="item.text"/>
                  <img v-if="item.image" :src="item.image" :alt="item.text" class="question__answers__item__picture"/>
                  <a class="question__answers__item__link" v-if="item.link" :href="item.link.url" :target="item.link.target">{{item.text}}</a>
                  <span class="question__answers__item__span" v-else>{{item.text}}</span>
                </div>

                <a v-if="item.info && item.info.download" class="question__answers__item__info" target="_blank" :href=item.info.download>
                  <img :src="returnBasePath('/assets/img/shared/icon-help.png')" alt="Info"/>
                  <span>{{item.info.label}}</span>
                </a>
                <div v-else-if="item.info" class="question__answers__item__info" @click="openInfoOverlay(item.info)">
                  <img :src="returnBasePath('/assets/img/shared/icon-help.png')" alt="Info"/>
                  <span>{{item.info.label}}</span>
                </div>
              </div>

            </div>
          </transition>
        </div>

      </div>

      <div v-if="hasOverlay" class="question__info visible-xs" @click="openInfoOverlay(config.info)">
        <img :src="returnBasePath('/assets/img/shared/icon-help.png')" alt="Info"/>
        <span @click="openInfoOverlay(config.info)">{{config.info.label}}</span>
      </div>
    </div>
  </transition>
</template>

<script>
  var answerBlocks = [];

  export default{
    props: ['dataObj', 'currentVariant'],
    data(){
      return {
        config: {},
        variant: this.currentVariant,
        hasInfo: false
      }
    },
    watch: {
      currentVariant(){
        this.variant = this.currentVariant;
      }
    },
    computed: {
      hasOverlay(){
        return this.config.info && this.config.info.type == 'overlay';
      }
    },
    methods: {
      checkIfOverflow(){
        var viewHeight = $('.question').innerHeight();
        var windowHeight = $(window).innerHeight();
        var footerHeight = $('.footer').innerHeight();
        var headerHeight = $('.header').innerHeight();
        var visibleHeight = windowHeight - footerHeight - headerHeight;
        if (viewHeight > visibleHeight) {
          $('.question').addClass('has-overflow');
        }
      },
      openInfoOverlay(obj){
        var vm = this;
        if (obj.type == 'overlay') {
          vm.$emit('open-overlay', obj);
        }
      },
      beforeEnter(){
        $('.question__answers__item').addClass('slideLeft-enter');
      },
      enter(){
        $('.question__answers__item').removeClass('slideLeft-enter');
      },
      leave(){
      },
      afterLeave(){
      },
      updateProps(){
        //Update component data when component is mounted or updated
        this.config = this.dataObj;
      },
      updateParentProps(){
        // Emits response from @retrieveNextStep(), precedently saved in Vue store, to parent component @App.vue
        var vm = this;
        var config = vm.$store.state.tempConfigObj;
        if (config) {
          vm.$emit('update-props', config);
          this.$forceUpdate();
        }
      },
      retrieveNextStep(questionId, answer, value){
        var answerId = answer.id;
        var isDisabled = answer.disabled;
        if (!isDisabled) {
          console.log(answer);
          if (!answer.link) {
            // Make AJAX call to retrieve next question node
            // @questionId {integer}:
            //    is the current node ID
            // @answerId {integer}:
            //    is the chosen answer ID
            var vm = this;

            console.log(vm.config);
            for (var i = 0; i < vm.config.answers.length; i++) {
              vm.config.answers[i].disabled = true;
            }
            if (vm.variant == 'question_split' && value) {
              vm.makeNextCall(questionId, answerId, function () {
                vm.updateParentProps();
              }, value)
            }
            else {
              vm.makeNextCall(questionId, answerId, function () {
                vm.updateParentProps();
              })
            }
          }
        }
      },
      matchHeight() {
        var vm = this;
        var allAnswers = $('.question__answers__item__wrapper');
        $.each(allAnswers, function (i, el) {
          if ($(el).find('> img').length) {
            answerBlocks.push(el);
          }
        });
        if (vm.config.template == 'question_split' || vm.config.template == 'question_split_alt' || vm.config.template == 'question_system') {
          var maxHeight = 0;
          $.each(answerBlocks, function (i, el) {
            var currentItem = $(el);
            var span = $(currentItem.find('span'));
            maxHeight = span.innerHeight() > maxHeight ? span.innerHeight() : maxHeight;
          });
          $.each(answerBlocks, function (i, el) {
            var currentItem = $(el);
            var span = $(currentItem.find('span'));
            span.css('height', maxHeight);
          });
        }
      }
    },
    mounted(){
      var vm = this;
      vm.updateProps();
      window.addEventListener('resize', vm.matchHeight);
      setTimeout(function () {
        vm.matchHeight();
      }, 100);
      setTimeout(function () {
        vm.checkIfOverflow();
      }, 1001);
    },
    updated(){
      var vm = this;
      vm.updateProps();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/question/Question.vue